var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmartControl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#363BC4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8623 18.9499C12.367 18.7573 12.1194 18.661 12.0471 18.5222C11.9844 18.4019 11.9843 18.2586 12.0468 18.1383C12.119 17.9994 12.3665 17.9028 12.8616 17.7096L26.9112 12.2268C27.3581 12.0524 27.5816 11.9652 27.7243 12.0129C27.8483 12.0544 27.9456 12.1517 27.9871 12.2757C28.0348 12.4184 27.9476 12.6419 27.7732 13.0888L22.2904 27.1384C22.0972 27.6335 22.0006 27.881 21.8617 27.9532C21.7414 28.0157 21.5981 28.0156 21.4778 27.9529C21.339 27.8806 21.2427 27.633 21.0501 27.1377L18.8636 21.5154C18.8245 21.4149 18.805 21.3646 18.7748 21.3223C18.748 21.2848 18.7152 21.252 18.6777 21.2252C18.6354 21.195 18.5851 21.1755 18.4846 21.1364L12.8623 18.9499Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartControl);
export default __webpack_public_path__ + "static/media/SmartControl.f03933a1a0a9321f11a53a66a461f4df.svg";
export { ForwardRef as ReactComponent };